import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import kebabCase from 'lodash/kebabCase';
import classNames from 'classnames';

import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { CatalogFilters } from 'common/components/AssetBrowser/components/filters/CatalogFilters';
import { MobileCatalogFilters } from 'common/components/AssetBrowser/components/filters/mobile_catalog_filters';
import CatalogResults from './catalog_results';
import { Tab } from '../lib/constants';

export const ResultsAndFilters = (props: {
  showFilters: boolean;
  activeTab: Tab;
  showAwaitingApprovalFilter: boolean;
  [key: string]: any;
}) => {
  const isMobile = useSelector((state: any) => state.windowDimensions.isMobile);

  const { showFilters, activeTab, showAwaitingApprovalFilter } = props;

  /** On mobile view default to closed filter drawer. */
  const [areMobileFiltersOpen, setAreMobileFiltersOpen] = useState(!isMobile);

  const resultsAndFiltersClasses = classNames('results-and-filters', kebabCase(activeTab));

  const filterOrder = [
    Filters.OnlyRecentlyViewed,
    Filters.EnrolledInArchival,
    Filters.ShowInternalTargetAudience,
    Filters.ShowPublicTargetAudience,
    Filters.ApprovalStatus,
    Filters.Version,
    Filters.AssetTypes,
    Filters.Source,
    Filters.Authority,
    // TODO EN-85150: These can be uncommented when autocomplete dropdown is converted to reusable component.
    // Filters.OwnedBy,
    // Filters.Visibility,
    // Filters.Category,
    // Filters.Tag,
    // Filters.CustomFacet,
    // Filters.Requester,
  ];

  return (
    <div className={resultsAndFiltersClasses}>
      <CatalogResults {...props} setShowFilters={setAreMobileFiltersOpen} />
      {showFilters && isMobile && areMobileFiltersOpen && (
        <MobileCatalogFilters
          filterOrder={filterOrder}
          showAwaitingApprovalFilter={showAwaitingApprovalFilter}
          activeTab={activeTab}
          setAreMobileFiltersOpen={setAreMobileFiltersOpen}
        />
      )}
      {showFilters && !isMobile && (
        <CatalogFilters
          filterOrder={filterOrder}
          showAwaitingApprovalFilter={showAwaitingApprovalFilter}
          activeTab={activeTab}
        />
      )}
    </div>
  );
};
